"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const is_present_1 = require("../arrays/is-present");
const is_present_2 = require("../numbers/is-present");
const is_present_3 = require("../objects/is-present");
const is_present_4 = require("../strings/is-present");
const is_present_5 = require("../booleans/is-present");
const is_present_6 = require("../functions/is-present");
const primitive_type_1 = require("./primitive-type");
const get_primitive_type_1 = require("./get-primitive-type");
const TYPE_PRESENCE_PREDICATE_MAP = {
    [primitive_type_1.PrimitiveType.String]: is_present_4.isPresent,
    [primitive_type_1.PrimitiveType.Function]: is_present_6.isPresent,
    [primitive_type_1.PrimitiveType.Object]: is_present_3.isPresent,
    [primitive_type_1.PrimitiveType.Array]: is_present_1.isPresent,
    [primitive_type_1.PrimitiveType.Boolean]: is_present_5.isPresent,
    [primitive_type_1.PrimitiveType.Nullable]: () => false,
    [primitive_type_1.PrimitiveType.Number]: is_present_2.isPresent,
};
/**
 * Asserts whether the given value is present or not. The definition of present
 * is opiniated. See examples for more information.
 *
 * @Param {any} value - The value to assert whether it is present.
 *
 * @Example
 *
 *   isPresent({})
 *   //=> false
 *
 *   isPresent({ food: 'pizza' })
 *   //=> true
 *
 *   isPresent([])
 *   //=> false
 *
 *   isPresent(['pizza'])
 *   //=> true
 *
 *   isPresent(false)
 *   //=> false
 *
 *   isPresent(true)
 *   //=> true
 *
 *   isPresent("\t\n ")
 *   //=> false
 *
 *   isPresent("pizza")
 *   //=> true
 *
 *   isPresent(0)
 *   //=> true
 *
 *   isPresent(NaN)
 *   //=> false
 */
function isPresent(value) {
    const type = get_primitive_type_1.getPrimitiveType(value);
    return TYPE_PRESENCE_PREDICATE_MAP[type](value);
}
exports.isPresent = isPresent;
//# sourceMappingURL=is-present.js.map